import { render } from "./BlogSection.vue?vue&type=template&id=bfbc8608&scoped=true"
import script from "./BlogSection.vue?vue&type=script&lang=js"
export * from "./BlogSection.vue?vue&type=script&lang=js"

import "./BlogSection.vue?vue&type=style&index=0&id=bfbc8608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbc8608"]])

export default __exports__